export enum EOrderStatus {
  CALL_SAP                = 'call sap',
  CALL_SAP_P58            = 'call sap p58',
  DRAFT                   = 'draft',
  REQUESTED               = 'requested',
  GENERATED               = 'generated',
  REQUEST                 = 'request',
  NEW                     = 'new',
  CREATED                 = 'created',
  IN_PROCESS              = 'in process',
  CONFIRMED               = 'confirmed',
  PARTIALLY_SHIPPED       = 'partially shipped',
  SHIPPED                 = 'shipped',
  INVOICE_SENT            = 'invoice sent',
  PAYMENT_PROCESSED       = 'payment processed',
  COMPLETED               = 'completed',
  RECEIVED                = 'received',
  WAITING                 = 'waiting',
  DECLINED                = 'declined',
  CANCELED                = 'canceled',
  PAYMENT_CANCELED        = 'payment canceled',
  PAYMENT_FAILED          = 'payment failed',
  PAYMENT_PENDING         = 'payment pending',
  PAYMENT_SUCCESSFUL      = 'payment successful',
  ISSUE                   = 'issue',
  ISSUE_P58               = 'issue p58',
  SEE_DETAILS             = 'see details',
  ORDER_PROCESSED         = 'order processed',
  ORDER_SUBMITTED         = 'order submitted',
  PENDING_DOCUMENTATION   = 'pending documentation',
  DOCUMENTATION_SUBMITTED = 'documentation submitted',
  DOCUMENT_ACCEPTED       = 'document accepted',
  UNDER_REVIEW            = 'under review',
  ORDER_COMPLETE          = 'order complete',
  ISSUE_WITH_ORDER        = 'issue with the order',
  CPQ_ORDER_DECLINED      = 'order declined'
}

export enum EHybrisOrderStatus {
  ORDER_CREATED          = 'order created',
  ON_HOLD                = 'on hold',
  BACKORDERED            = 'backordered',
  SCHEDULED_FOR_SHIPMENT = 'scheduled for shipment',
  IN_PROCESS             = 'in process',
  PARTIALLY_SHIPPED      = 'partially shipped',
  SHIPPED                = 'shipped',
  REJECTED               = 'rejected',
}

export enum EQuoteRequestStatus {
  REQUESTED = 'requested',
  GENERATED = 'generated',
  RECEIVED  = 'received',
  CANCELED  = 'canceled',
  WAITING   = 'waiting',
  CLOSED    = 'closed'
}

export enum EQuoteRequestVersionStatus {
  ACCEPTED    = 'accepted',
  CANCELED    = 'canceled',
  EMPTY       = 'empty',
  EXPIRED     = 'expired',
  NOT_ORDERED = 'not ordered',
  ORDERED     = 'ordered',
  OUTDATED    = 'outdated',
  PENDING     = 'pending',
  REJECTED    = 'rejected',
  REQUESTED   = 'requested',
}

export enum EScenarioType {
  ORDERS                   = 'orders',
  REQUEST                  = 'quote-requests',
  GENERATED_QUOTE          = 'generated-quote',
  CPQ                      = 'cpq',
  SPARE_PART_ORDER_DETAILS = 'spare-parts-order-details'
}

export interface IOrderStatusScenario {
  scenarioSteps: EOrderStatus[];
  hospitalSteps?: EOrderStatus[];
  siemensStep?: EOrderStatus;
  organizationSteps?: EOrderStatus[];
}

export interface IQuoteRequestVersionStatusScenario {
  scenarioSteps: EQuoteRequestVersionStatus[];
}

export class OrderStatus {
  static readonly DefaultOrderScenario: IOrderStatusScenario = {
    scenarioSteps: [],
  };

  static readonly ShippedSparePartOrderScenario: IOrderStatusScenario = {
    scenarioSteps: [
      EOrderStatus.NEW,
      EOrderStatus.CREATED,
      EOrderStatus.SHIPPED,
    ],
  };

  static readonly PartiallyShippedSparePartOrderScenario: IOrderStatusScenario = {
    scenarioSteps: [
      EOrderStatus.NEW,
      EOrderStatus.CREATED,
      EOrderStatus.PARTIALLY_SHIPPED,
    ],
  };

  static readonly CanceledSparePartOrderScenario: IOrderStatusScenario = {
    scenarioSteps: [
      EOrderStatus.NEW,
      EOrderStatus.CREATED,
      EOrderStatus.CANCELED,
    ],
  };

  static readonly IssueSparePartOrderScenario: IOrderStatusScenario = {
    scenarioSteps: [
      EOrderStatus.NEW,
      EOrderStatus.CREATED,
      EOrderStatus.ISSUE,
    ],
  };

  static readonly SeeDetailsSparePartOrderScenario: IOrderStatusScenario = {
    scenarioSteps: [
      EOrderStatus.NEW,
      EOrderStatus.CREATED,
      EOrderStatus.SEE_DETAILS,
    ],
  };

  static readonly DeclineScenario: IOrderStatusScenario = {
    scenarioSteps: [
      EOrderStatus.NEW,
      EOrderStatus.DECLINED,
    ],
  };

  static readonly CanceledOrderScenario: IOrderStatusScenario = {
    scenarioSteps: [
      EOrderStatus.REQUEST,
      EOrderStatus.NEW,
      EOrderStatus.CANCELED,
    ],
  };

  static readonly CanceledCCAvenuePaymentScenario: IOrderStatusScenario = {
    scenarioSteps: [
      EOrderStatus.REQUEST,
      EOrderStatus.NEW,
      EOrderStatus.PAYMENT_CANCELED,
    ],
  };

  static readonly FailedCCAvenuePaymentScenario: IOrderStatusScenario = {
    scenarioSteps: [
      EOrderStatus.REQUEST,
      EOrderStatus.NEW,
      EOrderStatus.PAYMENT_FAILED,
    ],
  };

  static readonly SuccessScenario: IOrderStatusScenario = {
    scenarioSteps: [
      EOrderStatus.REQUEST,
      EOrderStatus.NEW,
      EOrderStatus.CONFIRMED,
      EOrderStatus.SHIPPED,
      EOrderStatus.INVOICE_SENT,
      EOrderStatus.COMPLETED,
    ],
    hospitalSteps: [
      EOrderStatus.REQUEST,
      EOrderStatus.NEW,
    ],
    siemensStep: EOrderStatus.CONFIRMED,
  };

  static readonly IndiaSuccessScenario: IOrderStatusScenario = {
    scenarioSteps: [
      EOrderStatus.REQUEST,
      EOrderStatus.NEW,
      EOrderStatus.CONFIRMED,
      EOrderStatus.PAYMENT_PROCESSED,
      EOrderStatus.ORDER_PROCESSED,
      EOrderStatus.COMPLETED,
    ],
    hospitalSteps: [
      EOrderStatus.REQUEST,
      EOrderStatus.NEW,
    ],
    siemensStep: EOrderStatus.CONFIRMED,
  };

  static readonly IndiaCCAvenueSuccessScenario: IOrderStatusScenario = {
    scenarioSteps: [
      EOrderStatus.REQUEST,
      EOrderStatus.NEW,
      EOrderStatus.CONFIRMED,
      EOrderStatus.PAYMENT_PROCESSED,
      EOrderStatus.ORDER_PROCESSED,
      EOrderStatus.COMPLETED,
    ],
    hospitalSteps: [
      EOrderStatus.REQUEST,
      EOrderStatus.NEW,
    ],
    siemensStep: EOrderStatus.CONFIRMED,
  };

  static readonly JapanSuccessScenario: IOrderStatusScenario = {
    scenarioSteps: [
      EOrderStatus.REQUEST,
      EOrderStatus.NEW,
      EOrderStatus.CONFIRMED,
      EOrderStatus.SHIPPED,
      EOrderStatus.INVOICE_SENT,
    ],
    hospitalSteps: [
      EOrderStatus.REQUEST,
      EOrderStatus.NEW,
    ],
    siemensStep: EOrderStatus.CONFIRMED,
  };

  static readonly RequestSuccessScenario: IOrderStatusScenario = {
    scenarioSteps: [
      EOrderStatus.REQUESTED,
      EOrderStatus.RECEIVED,
    ],
  };

  static readonly RequestCanceledScenario: IOrderStatusScenario = {
    scenarioSteps: [
      EOrderStatus.REQUESTED,
      EOrderStatus.CANCELED,
    ],
  };

  static readonly RequestVersionAcceptedScenario: IQuoteRequestVersionStatusScenario = {
    scenarioSteps: [
      EQuoteRequestVersionStatus.REQUESTED,
      EQuoteRequestVersionStatus.PENDING,
      EQuoteRequestVersionStatus.ACCEPTED,
    ],
  };

  static readonly RequestVersionCanceledScenario: IQuoteRequestVersionStatusScenario = {
    scenarioSteps: [
      EQuoteRequestVersionStatus.REQUESTED,
      EQuoteRequestVersionStatus.CANCELED,
    ],
  };

  static readonly RequestVersionNotOrderedScenario: IQuoteRequestVersionStatusScenario = {
    scenarioSteps: [
      EQuoteRequestVersionStatus.REQUESTED,
      EQuoteRequestVersionStatus.NOT_ORDERED,
    ],
  };

  static readonly RequestVersionOrderedScenario: IQuoteRequestVersionStatusScenario = {
    scenarioSteps: [
      EQuoteRequestVersionStatus.REQUESTED,
      EQuoteRequestVersionStatus.ORDERED,
    ],
  };

  static readonly RequestVersionExpiredScenario: IQuoteRequestVersionStatusScenario = {
    scenarioSteps: [
      EQuoteRequestVersionStatus.REQUESTED,
      EQuoteRequestVersionStatus.PENDING,
      EQuoteRequestVersionStatus.EXPIRED,
    ],
  };

  static readonly RequestVersionOutdatedScenario: IQuoteRequestVersionStatusScenario = {
    scenarioSteps: [
      EQuoteRequestVersionStatus.REQUESTED,
      EQuoteRequestVersionStatus.OUTDATED,
    ],
  };

  static readonly RequestVersionPendingScenario: IQuoteRequestVersionStatusScenario = {
    scenarioSteps: [
      EQuoteRequestVersionStatus.REQUESTED,
      EQuoteRequestVersionStatus.PENDING,
      EQuoteRequestVersionStatus.EMPTY,
    ],
  };

  static readonly RequestVersionRejectedScenario: IQuoteRequestVersionStatusScenario = {
    scenarioSteps: [
      EQuoteRequestVersionStatus.REQUESTED,
      EQuoteRequestVersionStatus.PENDING,
      EQuoteRequestVersionStatus.REJECTED,
    ],
  };

  static readonly RequestVersionRequestedScenario: IQuoteRequestVersionStatusScenario = {
    scenarioSteps: [
      EQuoteRequestVersionStatus.REQUESTED,
      EQuoteRequestVersionStatus.EMPTY,
    ],
  };

  static readonly GeneratedQuoteSuccessScenario: IOrderStatusScenario = {
    scenarioSteps: [
      EOrderStatus.GENERATED,
      EOrderStatus.RECEIVED,
    ],
  };

  static readonly GeneratedQuoteCanceledScenario: IOrderStatusScenario = {
    scenarioSteps: [
      EOrderStatus.GENERATED,
      EOrderStatus.CANCELED,
    ],
  };

  static readonly CpqPendingScenario: IOrderStatusScenario = {
    scenarioSteps: [
      EOrderStatus.ORDER_SUBMITTED,
      EOrderStatus.PENDING_DOCUMENTATION,
      EOrderStatus.DOCUMENT_ACCEPTED,
      EOrderStatus.ORDER_COMPLETE,
    ],
    organizationSteps: [
      EOrderStatus.ORDER_SUBMITTED,
      EOrderStatus.PENDING_DOCUMENTATION,
    ],
    siemensStep: EOrderStatus.DOCUMENT_ACCEPTED,
  };

  static readonly CpqReviewScenario: IOrderStatusScenario = {
    scenarioSteps: [
      EOrderStatus.ORDER_SUBMITTED,
      EOrderStatus.DOCUMENTATION_SUBMITTED,
      EOrderStatus.UNDER_REVIEW,
      EOrderStatus.ORDER_COMPLETE,
    ],
    organizationSteps: [
      EOrderStatus.ORDER_SUBMITTED,
      EOrderStatus.DOCUMENTATION_SUBMITTED,
    ],
    siemensStep: EOrderStatus.UNDER_REVIEW,
  };

  static readonly CpqIssueWithOrderScenario: IOrderStatusScenario = {
    scenarioSteps: [
      EOrderStatus.ORDER_SUBMITTED,
      EOrderStatus.DOCUMENTATION_SUBMITTED,
      EOrderStatus.ISSUE_WITH_ORDER,
      EOrderStatus.ORDER_COMPLETE,
    ],
    organizationSteps: [
      EOrderStatus.ORDER_SUBMITTED,
      EOrderStatus.DOCUMENTATION_SUBMITTED,
    ],
    siemensStep: EOrderStatus.ISSUE_WITH_ORDER,
  };

  static readonly CpqUnderReviewScenario: IOrderStatusScenario = {
    scenarioSteps: [
      EOrderStatus.ORDER_SUBMITTED,
      EOrderStatus.DOCUMENTATION_SUBMITTED,
      EOrderStatus.UNDER_REVIEW,
      EOrderStatus.ORDER_COMPLETE,
    ],
    organizationSteps: [
      EOrderStatus.ORDER_SUBMITTED,
      EOrderStatus.DOCUMENTATION_SUBMITTED,
    ],
    siemensStep: EOrderStatus.UNDER_REVIEW,
  };

  static readonly CpqOrderCompleteScenario: IOrderStatusScenario = {
    scenarioSteps: [
      EOrderStatus.ORDER_SUBMITTED,
      EOrderStatus.DOCUMENTATION_SUBMITTED,
      EOrderStatus.DOCUMENT_ACCEPTED,
      EOrderStatus.ORDER_COMPLETE,
    ],
    organizationSteps: [
      EOrderStatus.ORDER_SUBMITTED,
      EOrderStatus.DOCUMENTATION_SUBMITTED,
    ],
    siemensStep: EOrderStatus.DOCUMENT_ACCEPTED,
  };

  static readonly CpqOrderDeclinedScenario: IOrderStatusScenario = {
    scenarioSteps: [
      EOrderStatus.ORDER_SUBMITTED,
      EOrderStatus.DOCUMENTATION_SUBMITTED,
      EOrderStatus.ISSUE_WITH_ORDER,
      EOrderStatus.CPQ_ORDER_DECLINED,
    ],
    organizationSteps: [
      EOrderStatus.ORDER_SUBMITTED,
      EOrderStatus.DOCUMENTATION_SUBMITTED,
    ],
    siemensStep: EOrderStatus.ISSUE_WITH_ORDER,
  };

  static PredefinedEquipmentFlowScenario: IOrderStatusScenario = {
    scenarioSteps: [
      EOrderStatus.REQUEST,
      EOrderStatus.NEW,
      EOrderStatus.CONFIRMED,
      EOrderStatus.COMPLETED,
    ],
    hospitalSteps: [
      EOrderStatus.REQUEST,
      EOrderStatus.NEW,
    ],
    siemensStep: EOrderStatus.CONFIRMED,
  };
}

export enum ESipayceCardPaymentStatus {
  FINISHED = 'FINISHED',
  OK       = 'OK',
  REDIRECT = 'REDIRECT',
  PENDING  = 'PENDING',
  ERROR    = 'ERROR',
  ABORTED  = 'ABORTED',
}
